module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_5.2b958aac.png";